import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

import { Language } from 'src/app/shared/data/constants';
import { UserService } from 'src/app/services/user.service';

import { Storage } from '@capacitor/storage';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  language = Language.German;
  readonly onUpdate$ = new Subject<Language>();

  constructor(private translateSrvc: TranslateService) {
    this.getLanguage().then((lang) => this.onUpdate$.next(lang));
  }

  async changeLanguage(language: Language) {
    this.translateSrvc.setDefaultLang(language);
    this.language = language;
    await Storage.set({ key: UserService.LANG_KEY, value: language });
    this.onUpdate$.next(language);
  }

  async getLanguage(): Promise<Language> {
    const language = (await Storage.get({ key: UserService.LANG_KEY })).value;
    if (language === Language.German) {
      this.language = Language.German;
    } else if (language === Language.English) {
      this.language = Language.English;
    }
    return this.language;
  }
}
